/**
 * ToolbarButton  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Button, IButtonProps } from "../Button/Button";

export enum TOOLBAR_BUTTON_SIZE {
	DEFAULT = "default",
	SMALL = "small"
}

export interface ToolbarButtonProps extends IButtonProps {
	style?: string;
	size?: TOOLBAR_BUTTON_SIZE;
}

export const ToolbarButton = React.forwardRef<HTMLDivElement, ToolbarButtonProps>(
	({ size, ...props }, ref) => {
		const baseClass = BEM(`edt-toolbar-button-${size}`, null, {
			style: props.style
		});

		return <Button {...props} baseClass={baseClass} ref={ref} />;
	}
);

ToolbarButton.defaultProps = {
	size: TOOLBAR_BUTTON_SIZE.DEFAULT
};
